import type { HTMLAttributes } from 'react';
import styles from './Columns.module.css';

export type ColumnsProps = HTMLAttributes<HTMLDivElement>;

/**
 * Layout primitive for pages with several form cards: two columns on wide
 * content areas, one column below 2 × 28rem (docs/ux-richtlinien.md §2,
 * "Breite"). A card standing alone (the only one, or the last of an odd
 * number) takes the full width. Children start at the top of their row.
 */
export function Columns({ className, ...rest }: ColumnsProps) {
  return <div className={[styles.columns, className].filter(Boolean).join(' ')} {...rest} />;
}
